import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';

import useAPI from '@/hooks/useAPI';
import {myMessage} from '@/b2c/api';

const ItemList = ({messages}) => {
  const {t: tr} = useTranslation('messageBox');

  return R.map(item => (
    <tr key={item.id} className='message'>
      <td className='date'>
        <p>{item.createDate}</p>
        <p>
          {tr('policy_no')} : {item.planNo}
        </p>
      </td>
      <td style={{paddingLeft: '20px'}}>
        <h3>{item.category}</h3>
        <p>{item.content}</p>
      </td>
    </tr>
  ))(messages);
};

const ItemListRwd = ({messages}) => {
  const {t: tr} = useTranslation('messageBox');

  return R.map(item => (
    <tr key={item.id} className='message'>
      <td>
        <p>{item.createDate}</p>
        <p>
          <strong>{item.category}</strong>
        </p>
        <p>{item.content}</p>
        <p>
          {tr('policy_no')} : {item.planNo}
        </p>
      </td>
    </tr>
  ))(messages);
};

const Message = () => {
  const {result, trigger, error} = useAPI(myMessage, {pending: true});
  const messages = R.propOr([], 'data', result);
  const {t: tr, i18n} = useTranslation('messageBox');

  useEffect(() => {
    trigger();
  }, i18n.language);

  if (error) {
    return (
      <div>
        <h1>Fail fetching data</h1>
        <p>{String(error)}</p>
      </div>
    );
  }

  return (
    <>
      <h1>{tr('title')}</h1>
      <table className='clientMessTable narrow'>
        <tbody>
          <tr>
            <th>{tr('subTitle')}</th>
            <th />
          </tr>
          <ItemListRwd messages={messages} />
        </tbody>
      </table>
      <table className='clientMessTable wide'>
        <tbody>
          <tr>
            <th>{tr('subTitle')}</th>
            <th>{tr('type')}</th>
          </tr>
          <ItemList messages={messages} />
        </tbody>
      </table>
    </>
  );
};

export default Message;
